module.exports = __webpack_public_path__ + "static/media/bg-pic-philant.286f0e34.jpg";